export const order_slab_url: string = "order_slab";
